import React from "react";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import { CategoriasProps, ItemDestaque } from "../../../../Cardapio/public/CatalogoPage";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";
import ImageLogoComponent from "../../../../../components/Image/ImageLogoComponent";
import SearchIcon from "../../../../../assets/icons/search_icon.png";
import TextFieldComponent from "../../../../../components/TextField/TextFieldComponent";
import ImageComponent from "../../../../../components/Image/ImageComponent";

interface NovoPedidoProdutosProps {
    itens: ItemDestaque[];
    searchItens: string;
    onChangeSearchItens: (value: string) => void;
    onChangeCarrinho: (item: ItemDestaque) => void;
}

const ProdutosComponent = (props: NovoPedidoProdutosProps) => {
    const handleChangeSearchItens = (value: string) => {
        props.onChangeSearchItens(value);
    }

    return <BoxComponent
        component="div"
        sx={{
            display: "flex", flexDirection: "column",
            flex: 5,
            gap: 2
        }}
    >
        <BoxComponent
            component="article"
            sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 2,
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF',
                //backgroundColor: "yellow",
                borderBottom: '0.67px solid var(--color-orange-87, #E8DFD5)',
                opacity: 1,
                height: 60,
                pl: 4, pr: 4
            }}
        >
            <BoxComponent component="div" sx={{ display: "flex", alignItems: "center", width: 450, height: 40, background: "#F8F5F0", borderRadius: "4.52px", border: "1px solid #E8DFD5" }}>
                <ImageLogoComponent
                    sx={{
                        margin: 1.85,
                        width: 20,
                        height: 20
                    }}
                    src={SearchIcon}
                    alt="icone_pesquisa_produto"
                />
                <TextFieldComponent
                    id="busca_produto"
                    placeholder="Encontre produtos por nome ou código PDV (Ctrl + b)"
                    variant="standard"
                    disableUnderline
                    fullWidth
                    value={props.searchItens}
                    onInput={(e) => {
                        const target = e.target as HTMLInputElement;
                        handleChangeSearchItens(target.value);
                    }}
                    sx={{
                    }}
                />
            </BoxComponent>
        </BoxComponent>

        <BoxComponent component="div"
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                pl: 4, pr: 4
            }}
        >
            {props.itens.map((item: ItemDestaque, index: number) => {
                const midiaAtiva = item.midias?.find(m => m.ativo);

                if (item.precoAtual == undefined || item.precoAtual == null) return <></>;

                if (midiaAtiva == undefined || midiaAtiva == null) return <></>;

                return <ButtonComponent
                    id={`item-${item.id}`}
                    key={`item-${item.id}`}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: '213.8px',
                        height: '171.01px',
                        boxSizing: 'border-box',
                        borderRadius: '6.02px',
                        backgroundColor: '#FFFFFF',
                        borderTop: '0.75px solid #E8DFD5',

                        boxShadow: '0px 1.51px 6.02px 0px rgba(61, 40, 23, 0.08)',

                        opacity: 1,
                        overflow: 'hidden',
                    }}
                    onClick={() => props.onChangeCarrinho(item)}
                >
                    {/* IMAGEM */}
                    <BoxComponent
                        component="div"
                        sx={{
                            width: '212.29px',
                            height: '96.34px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'linear-gradient(135deg, #F9FAFB 0%, #F8F5F0 100%)',
                            borderRadius: '6.02px',
                            overflow: 'hidden',
                        }}
                    >
                        <ImageComponent
                            alt={`item-${item.titulo}`}
                            src={midiaAtiva?.caminho}
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />
                    </BoxComponent>
                    {/* CONTEUDO */}
                    <BoxComponent component="div"
                        sx={{
                            width: '208.17px',
                            height: '73.17px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            gap: '6.02px',
                            boxSizing: 'border-box',
                            padding: '12.04px',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '6.02px',
                            opacity: 1,
                        }}
                    >
                        <TypographyComponent variant="h3"
                            sx={{
                                fontFamily: '"Font 2", sans-serif',
                                fontWeight: 600,
                                fontSize: '9.03px',
                                lineHeight: '12.04px',
                                letterSpacing: '0em',
                                color: '#3D2817',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                textAlign: "left"
                            }}
                        >
                            {item.titulo}
                        </TypographyComponent>

                        <TypographyComponent variant="h6"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 700,
                                fontSize: '9.86px',
                                lineHeight: '15.05px',
                                letterSpacing: '0em',
                                color: '#FF8C42',
                                display: 'block',
                                verticalAlign: 'middle',
                                textTransform: 'uppercase',
                                textAlign: "left"
                            }}
                        >
                            {formatNumberToDinheiro(item.precoAtual)}
                        </TypographyComponent>
                    </BoxComponent>
                </ButtonComponent>
            })}
        </BoxComponent>
    </BoxComponent>
}

export default ProdutosComponent;